<div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title">
    Terms of Service
  </h4>
</div>

<div class="modal-body" #tosWrapper [innerHTML]="terms"></div>

<div class="modal-footer">
  <button
    type="button"
    class="btn btn-primary"
    (click)="activeModal.close('tos_accepted')"
    [disabled]="!canAcceptTOS"
  >
    I accept these terms
  </button>
</div>
